var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Evidencia_de_audio",
    "data-name": "Evidencia de audio",
    transform: "translate(16693 -1807)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2979",
    "data-name": "Rect\\xE1ngulo 2979",
    width: 130,
    height: 130,
    transform: "translate(-16693 1807)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Evidencia_de_audio-2",
    "data-name": "Evidencia de audio",
    transform: "translate(-1330.293 -306.591)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2612",
    "data-name": "Grupo 2612",
    transform: "translate(-15356 2146.446)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3856",
    "data-name": "Trazado 3856",
    d: "M249.74,363.9a.429.429,0,0,1-.429-.429v-15a.429.429,0,1,1,.857,0v15A.429.429,0,0,1,249.74,363.9Z",
    transform: "translate(-249.312 -338.61)",
    fill: "#c20e30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3857",
    "data-name": "Trazado 3857",
    d: "M256.741,363.113a.429.429,0,0,1-.429-.429V342.968a.429.429,0,0,1,.857,0v19.717A.429.429,0,0,1,256.741,363.113Z",
    transform: "translate(-253.311 -335.467)",
    fill: "#c20e30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3858",
    "data-name": "Trazado 3858",
    d: "M263.74,362.614a.429.429,0,0,1-.429-.429V339.468a.429.429,0,0,1,.857,0v22.717A.429.429,0,0,1,263.74,362.614Z",
    transform: "translate(-257.311 -333.467)",
    fill: "#c20e30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3859",
    "data-name": "Trazado 3859",
    d: "M270.74,339.469c-.237,0-.429-.058-.429-.129v-9.172c0-.071.192-.129.429-.129s.429.058.429.129v9.172C271.169,339.411,270.977,339.469,270.74,339.469Z",
    transform: "translate(-261.311 -317.395)",
    fill: "#c20e30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3860",
    "data-name": "Trazado 3860",
    d: "M277.74,337.542c-.237,0-.429-.094-.429-.21V316.749c0-.116.192-.21.429-.21s.429.094.429.21v20.583C278.169,337.448,277.977,337.542,277.74,337.542Z",
    transform: "translate(-265.31 -309.681)",
    fill: "#c20e30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3861",
    "data-name": "Trazado 3861",
    d: "M284.74,339.469c-.237,0-.429-.058-.429-.129v-9.172c0-.071.192-.129.429-.129s.429.058.429.129v9.172C285.169,339.411,284.977,339.469,284.74,339.469Z",
    transform: "translate(-269.31 -317.395)",
    fill: "#c20e30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3862",
    "data-name": "Trazado 3862",
    d: "M291.74,338.541c-.237,0-.429-.078-.429-.174V323.714c0-.1.192-.174.429-.174s.429.078.429.174v14.653C292.169,338.463,291.977,338.541,291.74,338.541Z",
    transform: "translate(-273.31 -313.681)",
    fill: "#c20e30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3863",
    "data-name": "Trazado 3863",
    d: "M298.74,362.828a.429.429,0,0,1-.429-.429V340.968a.429.429,0,1,1,.857,0V362.4A.429.429,0,0,1,298.74,362.828Z",
    transform: "translate(-277.309 -334.324)",
    fill: "#c20e30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3864",
    "data-name": "Trazado 3864",
    d: "M305.74,362.257a.429.429,0,0,1-.429-.429v-24.86a.429.429,0,1,1,.857,0v24.86A.429.429,0,0,1,305.74,362.257Z",
    transform: "translate(-281.309 -332.039)",
    fill: "#c20e30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3865",
    "data-name": "Trazado 3865",
    d: "M312.74,363.9a.429.429,0,0,1-.429-.429v-15a.429.429,0,1,1,.857,0v15A.429.429,0,0,1,312.74,363.9Z",
    transform: "translate(-285.309 -338.61)",
    fill: "#c20e30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3866",
    "data-name": "Trazado 3866",
    d: "M318.74,363.9a.429.429,0,0,1-.429-.429v-15a.429.429,0,0,1,.857,0v15A.429.429,0,0,1,318.74,363.9Z",
    transform: "translate(-288.737 -338.61)",
    fill: "#c20e30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3867",
    "data-name": "Trazado 3867",
    d: "M325.74,363.113a.429.429,0,0,1-.429-.429V342.968a.429.429,0,0,1,.857,0v19.717A.429.429,0,0,1,325.74,363.113Z",
    transform: "translate(-292.736 -335.467)",
    fill: "#c20e30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3868",
    "data-name": "Trazado 3868",
    d: "M332.74,362.614a.429.429,0,0,1-.429-.429V339.468a.429.429,0,0,1,.857,0v22.717A.429.429,0,0,1,332.74,362.614Z",
    transform: "translate(-296.736 -333.467)",
    fill: "#c20e30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3869",
    "data-name": "Trazado 3869",
    d: "M339.74,339.469c-.237,0-.429-.058-.429-.129v-9.172c0-.071.192-.129.429-.129s.429.058.429.129v9.172C340.169,339.411,339.977,339.469,339.74,339.469Z",
    transform: "translate(-300.736 -317.395)",
    fill: "#c20e30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3870",
    "data-name": "Trazado 3870",
    d: "M346.74,335.258c-.237,0-.429-.118-.429-.263V300.8c0-.145.192-.263.429-.263s.429.118.429.263v34.193C347.169,335.14,346.977,335.258,346.74,335.258Z",
    transform: "translate(-304.735 -300.539)",
    fill: "#c20e30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3871",
    "data-name": "Trazado 3871",
    d: "M353.74,339.469c-.237,0-.429-.058-.429-.129v-9.172c0-.071.192-.129.429-.129s.429.058.429.129v9.172C354.169,339.411,353.977,339.469,353.74,339.469Z",
    transform: "translate(-308.735 -317.395)",
    fill: "#c20e30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3872",
    "data-name": "Trazado 3872",
    d: "M360.74,338.541c-.237,0-.429-.078-.429-.174V323.714c0-.1.192-.174.429-.174s.429.078.429.174v14.653C361.169,338.463,360.977,338.541,360.74,338.541Z",
    transform: "translate(-312.735 -313.681)",
    fill: "#c20e30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3873",
    "data-name": "Trazado 3873",
    d: "M367.74,362.828a.429.429,0,0,1-.429-.429V340.968a.429.429,0,0,1,.857,0V362.4A.429.429,0,0,1,367.74,362.828Z",
    transform: "translate(-316.734 -334.324)",
    fill: "#c20e30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3874",
    "data-name": "Trazado 3874",
    d: "M374.74,362.257a.429.429,0,0,1-.429-.429v-24.86a.429.429,0,1,1,.857,0v24.86A.429.429,0,0,1,374.74,362.257Z",
    transform: "translate(-320.734 -332.039)",
    fill: "#c20e30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3875",
    "data-name": "Trazado 3875",
    d: "M381.74,363.9a.429.429,0,0,1-.429-.429v-15a.429.429,0,0,1,.857,0v15A.429.429,0,0,1,381.74,363.9Z",
    transform: "translate(-324.734 -338.61)",
    fill: "#c20e30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3876",
    "data-name": "Trazado 3876",
    d: "M387.74,363.9a.429.429,0,0,1-.429-.429v-15a.429.429,0,1,1,.857,0v15A.429.429,0,0,1,387.74,363.9Z",
    transform: "translate(-328.162 -338.61)",
    fill: "#c20e30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3877",
    "data-name": "Trazado 3877",
    d: "M394.74,363.113a.429.429,0,0,1-.429-.429V342.968a.429.429,0,1,1,.857,0v19.717A.429.429,0,0,1,394.74,363.113Z",
    transform: "translate(-332.161 -335.467)",
    fill: "#c20e30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3878",
    "data-name": "Trazado 3878",
    d: "M401.74,362.614a.429.429,0,0,1-.429-.429V339.468a.429.429,0,0,1,.857,0v22.717A.429.429,0,0,1,401.74,362.614Z",
    transform: "translate(-336.161 -333.467)",
    fill: "#c20e30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3879",
    "data-name": "Trazado 3879",
    d: "M408.74,339.469c-.237,0-.429-.058-.429-.129v-9.172c0-.071.192-.129.429-.129s.429.058.429.129v9.172C409.169,339.411,408.977,339.469,408.74,339.469Z",
    transform: "translate(-340.161 -317.395)",
    fill: "#c20e30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3880",
    "data-name": "Trazado 3880",
    d: "M415.74,337.542c-.237,0-.429-.094-.429-.21V316.749c0-.116.192-.21.429-.21s.429.094.429.21v20.583C416.169,337.448,415.977,337.542,415.74,337.542Z",
    transform: "translate(-344.16 -309.681)",
    fill: "#c20e30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3882",
    "data-name": "Trazado 3882",
    d: "M422.74,339.469c-.237,0-.429-.058-.429-.129v-9.172c0-.071.192-.129.429-.129s.429.058.429.129v9.172C423.169,339.411,422.977,339.469,422.74,339.469Z",
    transform: "translate(-348.16 -317.395)",
    fill: "#c20e30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3883",
    "data-name": "Trazado 3883",
    d: "M429.74,338.541c-.237,0-.429-.078-.429-.174V323.714c0-.1.192-.174.429-.174s.429.078.429.174v14.653C430.169,338.463,429.977,338.541,429.74,338.541Z",
    transform: "translate(-352.16 -313.681)",
    fill: "#c20e30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3884",
    "data-name": "Trazado 3884",
    d: "M436.74,362.828a.429.429,0,0,1-.429-.429V340.968a.429.429,0,0,1,.857,0V362.4A.429.429,0,0,1,436.74,362.828Z",
    transform: "translate(-356.159 -334.324)",
    fill: "#c20e30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3885",
    "data-name": "Trazado 3885",
    d: "M443.74,362.257a.429.429,0,0,1-.429-.429v-24.86a.429.429,0,1,1,.857,0v24.86A.429.429,0,0,1,443.74,362.257Z",
    transform: "translate(-360.159 -332.039)",
    fill: "#c20e30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3886",
    "data-name": "Trazado 3886",
    d: "M450.74,363.9a.429.429,0,0,1-.429-.429v-15a.429.429,0,1,1,.857,0v15A.429.429,0,0,1,450.74,363.9Z",
    transform: "translate(-364.159 -338.61)",
    fill: "#c20e30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3887",
    "data-name": "Trazado 3887",
    d: "M456.74,363.9a.429.429,0,0,1-.429-.429v-15a.429.429,0,1,1,.857,0v15A.429.429,0,0,1,456.74,363.9Z",
    transform: "translate(-367.587 -338.61)",
    fill: "#c20e30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3888",
    "data-name": "Trazado 3888",
    d: "M463.74,363.113a.429.429,0,0,1-.429-.429V342.968a.429.429,0,0,1,.857,0v19.717A.429.429,0,0,1,463.74,363.113Z",
    transform: "translate(-371.586 -335.467)",
    fill: "#c20e30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3889",
    "data-name": "Trazado 3889",
    d: "M470.74,362.614a.429.429,0,0,1-.429-.429V339.468a.429.429,0,0,1,.857,0v22.717A.429.429,0,0,1,470.74,362.614Z",
    transform: "translate(-375.586 -333.467)",
    fill: "#c20e30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3890",
    "data-name": "Trazado 3890",
    d: "M477.74,339.469c-.237,0-.429-.058-.429-.129v-9.172c0-.071.192-.129.429-.129s.429.058.429.129v9.172C478.169,339.411,477.977,339.469,477.74,339.469Z",
    transform: "translate(-379.586 -317.395)",
    fill: "#c20e30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3891",
    "data-name": "Trazado 3891",
    d: "M484.74,335.258c-.237,0-.429-.118-.429-.263V300.8c0-.145.192-.263.429-.263s.429.118.429.263v34.193C485.169,335.14,484.977,335.258,484.74,335.258Z",
    transform: "translate(-383.585 -300.539)",
    fill: "#c20e30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3892",
    "data-name": "Trazado 3892",
    d: "M491.74,339.469c-.237,0-.429-.058-.429-.129v-9.172c0-.071.192-.129.429-.129s.429.058.429.129v9.172C492.169,339.411,491.977,339.469,491.74,339.469Z",
    transform: "translate(-387.585 -317.395)",
    fill: "#c20e30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3893",
    "data-name": "Trazado 3893",
    d: "M498.74,338.541c-.237,0-.429-.078-.429-.174V323.714c0-.1.192-.174.429-.174s.429.078.429.174v14.653C499.169,338.463,498.977,338.541,498.74,338.541Z",
    transform: "translate(-391.585 -313.681)",
    fill: "#c20e30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3894",
    "data-name": "Trazado 3894",
    d: "M505.74,362.828a.429.429,0,0,1-.429-.429V340.968a.429.429,0,1,1,.857,0V362.4A.429.429,0,0,1,505.74,362.828Z",
    transform: "translate(-395.584 -334.324)",
    fill: "#c20e30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3895",
    "data-name": "Trazado 3895",
    d: "M512.74,362.257a.429.429,0,0,1-.429-.429v-24.86a.429.429,0,1,1,.857,0v24.86A.429.429,0,0,1,512.74,362.257Z",
    transform: "translate(-399.584 -332.039)",
    fill: "#c20e30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3896",
    "data-name": "Trazado 3896",
    d: "M519.74,363.9a.429.429,0,0,1-.429-.429v-15a.429.429,0,1,1,.857,0v15A.429.429,0,0,1,519.74,363.9Z",
    transform: "translate(-403.584 -338.61)",
    fill: "#c20e30"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2613",
    "data-name": "Grupo 2613",
    transform: "translate(-15311.279 2187.592)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1078",
    "data-name": "Grupo 1078"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trazado_4436",
    "data-name": "Trazado 4436",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.572,0A13.572,13.572,0,1,1,0,13.572,13.572,13.572,0,0,1,13.572,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 13.57172870635986 0.9999980926513672 C 10.21369934082031 0.9999980926513672 7.056657791137695 2.307687759399414 4.682168960571289 4.682168960571289 C 2.307687759399414 7.056657791137695 0.9999980926513672 10.21369934082031 0.9999980926513672 13.57172870635986 C 0.9999980926513672 16.92975997924805 2.307687759399414 20.08679962158203 4.682168960571289 22.46128845214844 C 7.056657791137695 24.83576965332031 10.21369934082031 26.14345932006836 13.57172870635986 26.14345932006836 C 16.92975997924805 26.14345932006836 20.08679962158203 24.83576965332031 22.46128845214844 22.46128845214844 C 24.83576965332031 20.08679962158203 26.14345932006836 16.92975997924805 26.14345932006836 13.57172870635986 C 26.14345932006836 10.21369934082031 24.83576965332031 7.056657791137695 22.46128845214844 4.682168960571289 C 20.08679962158203 2.307687759399414 16.92975997924805 0.9999980926513672 13.57172870635986 0.9999980926513672 M 13.57172870635986 -1.9073486328125e-06 C 21.06718826293945 -1.9073486328125e-06 27.14345932006836 6.076269149780273 27.14345932006836 13.57172870635986 C 27.14345932006836 21.06718826293945 21.06718826293945 27.14345932006836 13.57172870635986 27.14345932006836 C 6.076269149780273 27.14345932006836 -1.9073486328125e-06 21.06718826293945 -1.9073486328125e-06 13.57172870635986 C -1.9073486328125e-06 6.076269149780273 6.076269149780273 -1.9073486328125e-06 13.57172870635986 -1.9073486328125e-06 Z",
    stroke: "none",
    fill: "#20313d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Componente_1852_8",
    "data-name": "Componente 1852 \\u2013 8",
    transform: "translate(8.402 7.755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4435",
    "data-name": "Trazado 4435",
    d: "M0,0H11.548V11.548H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4434",
    "data-name": "Trazado 4434",
    d: "M3.947,1A1.917,1.917,0,0,1,7.318,1L11,7.563a2.015,2.015,0,0,1-1.686,3.025H1.952A2.015,2.015,0,0,1,.266,7.563Z",
    transform: "translate(10.588 0.303) rotate(90)",
    fill: "#243746"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvAudio);
export default __webpack_public_path__ + "static/media/evAudio.2fc1ca95ba5deb26dc4d5a51fd518d48.svg";
export { ForwardRef as ReactComponent };